document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  const megaItems = [...document.querySelectorAll('[data-mega-item]')];
  const closeMegaMenus = (except = null) => {
    megaItems.forEach((item) => {
      if (item === except) return;
      const button = item.querySelector('[data-mega-toggle]');
      const panel = item.querySelector('[data-mega-panel]');
      if (button) button.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      item.classList.remove('is-open');
    });
  };

  megaItems.forEach((item) => {
    const button = item.querySelector('[data-mega-toggle]');
    const panel = item.querySelector('[data-mega-panel]');
    if (!button || !panel) return;
    const open = () => {
      closeMegaMenus(item);
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');
    };
    const close = () => {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
    };
    button.addEventListener('click', () => panel.hidden ? open() : close());
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-mega-item]')) closeMegaMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMegaMenus();
  });

  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  const collectionPreferenceKeys = {
    perPage: 'klp.collection.productsPerPage',
    cardSize: 'klp.collection.cardSize',
  };
  const collectionPerPageValues = new Set(['12', '24', '36', '48']);
  const collectionCardSizes = new Set(['small', 'medium', 'large']);
  const readCollectionPreference = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };
  const saveCollectionPreference = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.warn('KLP display preference could not be saved.', error);
    }
  };
  const collectionUrlForPerPage = (href, perPage) => {
    const url = new URL(href, window.location.origin);
    url.searchParams.delete('page');
    if (perPage === '24') url.searchParams.delete('view');
    else url.searchParams.set('view', `per-${perPage}`);
    return url;
  };

  document.querySelectorAll('[data-collection-preferences]').forEach((toolbar) => {
    const collectionBody = toolbar.closest('.collection-body');
    const perPageSelect = toolbar.querySelector('[data-products-per-page]');
    const cardSizeSelect = toolbar.querySelector('[data-card-size-select]');
    if (!collectionBody || !perPageSelect || !cardSizeSelect) return;

    const currentPerPage = collectionPerPageValues.has(toolbar.dataset.currentPerPage)
      ? toolbar.dataset.currentPerPage
      : '24';
    const storedCardSize = readCollectionPreference(collectionPreferenceKeys.cardSize);
    const initialCardSize = collectionCardSizes.has(storedCardSize) ? storedCardSize : 'medium';
    collectionBody.dataset.cardSize = initialCardSize;
    cardSizeSelect.value = initialCardSize;
    perPageSelect.value = currentPerPage;

    cardSizeSelect.addEventListener('change', () => {
      const nextSize = collectionCardSizes.has(cardSizeSelect.value) ? cardSizeSelect.value : 'medium';
      collectionBody.dataset.cardSize = nextSize;
      saveCollectionPreference(collectionPreferenceKeys.cardSize, nextSize);
    });

    perPageSelect.addEventListener('change', () => {
      const nextPerPage = collectionPerPageValues.has(perPageSelect.value) ? perPageSelect.value : '24';
      saveCollectionPreference(collectionPreferenceKeys.perPage, nextPerPage);
      window.location.assign(collectionUrlForPerPage(window.location.href, nextPerPage).toString());
    });

    const storedPerPage = readCollectionPreference(collectionPreferenceKeys.perPage);
    const preferredPerPage = collectionPerPageValues.has(storedPerPage) ? storedPerPage : currentPerPage;
    if (preferredPerPage !== currentPerPage) {
      window.location.replace(collectionUrlForPerPage(window.location.href, preferredPerPage).toString());
      return;
    }

    const paginationView = preferredPerPage === '24' ? '' : `per-${preferredPerPage}`;
    document.querySelectorAll('[data-collection-pagination] a').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (paginationView) url.searchParams.set('view', paginationView);
      else url.searchParams.delete('view');
      link.href = url.toString();
    });
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;
        const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.step || 0));
        input.value = String(next);
      });
    });
  });

  let searchIndexPromise;
  const loadSearchIndex = (url) => {
    if (!searchIndexPromise) {
      searchIndexPromise = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Search index request failed: ${response.status}`);
          return response.json();
        })
        .then((payload) => Array.isArray(payload.products) ? payload.products : []);
    }
    return searchIndexPromise;
  };

  const normalized = (value) => String(value || '').trim().toLowerCase();
  const digitsOnly = (value) => String(value || '').replace(/\D/g, '');
  const scoreSearchEntry = (entry, query, exactOnly = false) => {
    const term = normalized(query);
    const sku = normalized(entry.sku);
    const barcode = normalized(entry.barcode);
    if (!term) return -1;
    if (sku === term || barcode === term) return 0;
    if (/^\d+$/.test(term) && (digitsOnly(sku) === term || digitsOnly(barcode) === term)) return 1;
    if (exactOnly || term.length < 3) return -1;
    if (sku.startsWith(term) || barcode.startsWith(term)) return 2;
    if (/^\d+$/.test(term) && (digitsOnly(sku).startsWith(term) || digitsOnly(barcode).startsWith(term))) return 3;
    return -1;
  };

  const findSearchMatches = (index, query, exactOnly = false) => {
    const ranked = index
      .map((entry) => ({ entry, score: scoreSearchEntry(entry, query, exactOnly) }))
      .filter((item) => item.score >= 0)
      .sort((left, right) => left.score - right.score || normalized(left.entry.sku).localeCompare(normalized(right.entry.sku)));
    const unique = [];
    const seen = new Set();
    for (const item of ranked) {
      const key = `${item.entry.url}|${normalized(item.entry.sku)}|${normalized(item.entry.barcode)}`;
      if (seen.has(key)) continue;
      seen.add(key);
      unique.push(item.entry);
      if (unique.length === 8) break;
    }
    return unique;
  };

  const renderSearchSuggestions = (container, matches, query) => {
    container.replaceChildren();
    if (!matches.length) {
      container.hidden = true;
      return;
    }
    const heading = document.createElement('p');
    heading.className = 'product-search-suggestions__heading';
    heading.textContent = `${matches.length} ITEM${matches.length === 1 ? '' : 'S'} MATCH “${String(query).trim()}”`;
    container.append(heading);
    matches.forEach((entry) => {
      const link = document.createElement('a');
      link.className = 'product-search-suggestion';
      link.href = entry.url;
      link.setAttribute('role', 'option');
      if (entry.imageUrl) {
        const image = document.createElement('img');
        image.src = entry.imageUrl;
        image.alt = entry.imageAlt || entry.title || '';
        image.loading = 'lazy';
        link.append(image);
      }
      const copy = document.createElement('span');
      copy.className = 'product-search-suggestion__copy';
      const title = document.createElement('strong');
      title.textContent = entry.title || 'Product';
      const meta = document.createElement('small');
      const identifiers = [entry.sku ? `SKU ${entry.sku}` : '', entry.barcode ? `BARCODE ${entry.barcode}` : ''].filter(Boolean);
      meta.textContent = identifiers.join(' · ');
      copy.append(title, meta);
      const arrow = document.createElement('span');
      arrow.className = 'product-search-suggestion__arrow';
      arrow.textContent = '↗';
      link.append(copy, arrow);
      container.append(link);
    });
    container.hidden = false;
  };

  document.querySelectorAll('[data-product-search]').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const suggestions = form.querySelector('[data-search-suggestions]');
    const indexUrl = form.dataset.searchIndexUrl;
    if (!input || !suggestions || !indexUrl) return;
    let requestNumber = 0;
    let debounce;

    const updateSuggestions = async () => {
      const query = input.value.trim();
      const currentRequest = ++requestNumber;
      if (query.length < 3) {
        renderSearchSuggestions(suggestions, [], query);
        return;
      }
      try {
        const index = await loadSearchIndex(indexUrl);
        if (currentRequest !== requestNumber) return;
        renderSearchSuggestions(suggestions, findSearchMatches(index, query), query);
      } catch (error) {
        console.warn('KLP product search index unavailable.', error);
        renderSearchSuggestions(suggestions, [], query);
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(debounce);
      debounce = window.setTimeout(updateSuggestions, 120);
    });
    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 3) updateSuggestions();
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') renderSearchSuggestions(suggestions, [], input.value);
    });

    form.addEventListener('submit', async (event) => {
      const query = input.value.trim();
      if (!query) return;
      event.preventDefault();
      form.setAttribute('aria-busy', 'true');
      try {
        const index = await loadSearchIndex(indexUrl);
        const exactMatches = findSearchMatches(index, query, true);
        const productUrls = [...new Set(exactMatches.map((entry) => entry.url))];
        if (productUrls.length === 1) {
          window.location.assign(productUrls[0]);
          return;
        }
        if (exactMatches.length > 1) {
          renderSearchSuggestions(suggestions, exactMatches, query);
          form.removeAttribute('aria-busy');
          return;
        }
      } catch (error) {
        console.warn('KLP item-number lookup unavailable; using standard search.', error);
      }
      HTMLFormElement.prototype.submit.call(form);
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-search-suggestions]').forEach((container) => {
      if (!container.closest('form')?.contains(event.target)) container.hidden = true;
    });
  });
});
